import { hash } from './hash'

export const environment = {
    production: true,
    hash: hash
}
